<template>
    <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div class="text-center">
            <p class="text-9xl font-semibold text-[#36a8dd] ">404</p>
            <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
            <p class="mt-6 text-base leading-7 text-gray-600">{{ messages[Math.floor(Math.random() * 6)] }}</p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
                <a href="/"
                    class="rounded-md bg-[#36a8dd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#36a8dd] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#36a8dd] ">Go
                    back home</a>
                    
            </div>
        </div>
    </main>
</template>

<script lang='ts' setup>
const messages = [
    
    "The internet isn't broken, But we can't find what you're looking for.",
    "Sorry, we couldn’t find the page you’re looking for.",
    ":(",
    "Uh Oh, it seems we can't find this page",
    "Somethings wrong, we can't find this page.",
    "This doesn't seem right. Shall we go back?",

]

</script>